import { useEffect } from 'react';
import { db } from '../config/config-firebase';
import { doc, getDoc } from 'firebase/firestore';
//

import AuthAction, { ProjectInfo } from '../reduxStore/authReducer/authAction';
import { useAppDispatch, useAppSelector } from '../reduxStore/utils/reduxHooks';
import { fsApiConfigCol } from '../config/config-firestore';
import {
  FirestoreProjectTokenMap,
  normalizeProjectTokenMap,
} from './projectTokenNormalizer';

const fetchTokens = async (token?:string):Promise<ProjectInfo[]> => {
  try {
    if (!token) return [];
    const docRef = doc(db, fsApiConfigCol, token);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data() as FirestoreProjectTokenMap;
      return normalizeProjectTokenMap(data);
    }

    return [];
  } catch (e) {
    return [];
  }
};

const firestoreListener = () => {
  const authData = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  // Get token from redux or localStorage (prefer redux if exists)
  const reduxToken = authData.token;
  const localToken = typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;
  const token = reduxToken || localToken || undefined;

  useEffect(() => {
    // If either redux token changes or localStorage token exists, fetch
    if (token) {
      fetchTokens(token)
        .then((data) => {
          dispatch({
            type: AuthAction.SET_PRJ_TOKEN,
            payload: data,
          });
        });
    }
  }, [reduxToken, localToken]);

  return null;
};

export default firestoreListener;
